import React, { createContext } from 'react';
import { Flex } from '../Flex/Flex.js';

const TabsContext = createContext({});
function TabsProvider({ children, currentTab, onChange, }) {
    const onChangeTab = (tabKey) => {
        if (onChange) {
            onChange(tabKey);
        }
    };
    return (React.createElement(TabsContext.Provider, { value: { currentTab, onChange: onChangeTab } },
        React.createElement(Flex, { "data-testid": `tab-${currentTab}`, flexDirection: "column" }, children)));
}

export { TabsContext, TabsProvider as default };
